module.exports = __webpack_public_path__ + "img/car_5.e9db4dc2.jpeg";